export type OutageSeverityClass =
  | 'online' | 'minor' | 'moderate' | 'significant' | 'severe';

export interface OutageSeverityBucket {
  className: OutageSeverityClass;
  label: string;
  min: number; // inclusive lower bound of customers out
}

// Ordered high -> low so the legend reads severe-first and lookup short-circuits.
export const OUTAGE_SEVERITY_BUCKETS: readonly OutageSeverityBucket[] = [
  { className: 'severe', label: '500+', min: 500 },
  { className: 'significant', label: '100–499', min: 100 },
  { className: 'moderate', label: '25–99', min: 25 },
  { className: 'minor', label: '1–24', min: 1 },
  { className: 'online', label: 'Online', min: 0 },
] as const;

export function outageSeverityClass(customersOut: number): OutageSeverityClass {
  if (!(customersOut > 0)) return 'online';
  for (const bucket of OUTAGE_SEVERITY_BUCKETS) {
    if (customersOut >= bucket.min) return bucket.className;
  }
  return 'online';
}
